import { AddOutlined, DeleteOutline, EditOutlined } from "@mui/icons-material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CustomButton, TableData } from "components";
import { confirmAlert, errorAlert } from "helpers/alerts";
import { setTitle } from "redux/slices/uiSlice";
import { deleteCuentaService, getCuentasService } from "services/abonos/abonosService";
import { removeCuenta, setCuentas, setCurrentCuenta } from "redux/slices/abonos/abonosSlice";
import { Box } from "@mui/material";

const getCuentaId = (cuenta) => cuenta?._id || cuenta?.id;

const CuentasScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cuentas } = useSelector((store) => store.abonos);

  useEffect(() => {
    dispatch(setTitle("Administración de Cuentas"));
    getCuentasService()
      .then((response) => dispatch(setCuentas(response || [])))
      .catch((error) => errorAlert(error));
    // eslint-disable-next-line
  }, []);

  const handleAdd = () => navigate("crear");

  const handleEdit = (cuenta) => {
    dispatch(setCurrentCuenta(cuenta));
    navigate("editar");
  };

  const handleDelete = (cuenta) => {
    const id = getCuentaId(cuenta);
    confirmAlert({
      title: "¿Eliminar cuenta bancaria?",
      text: "La cuenta seleccionada será eliminada.",
      onConfirm: () => {
        deleteCuentaService(id)
          .then(() => dispatch(removeCuenta(id)))
          .catch((error) => errorAlert(error));
      },
    });
  };

  return (
    <Box mt={2}>
      <TableData
        dataRows={cuentas || []}
        headerButtons={[
          <CustomButton
            dark={true}
            icon={<AddOutlined />}
            key={"addCuenta"}
            name={"Cuenta"}
            click={handleAdd}
          />,
        ]}
        dataTitle={["Banco", "N° Cuenta", "N° CLABE", "Beneficiario"]}
        formatter={(row) => [
          row?.bank || "-",
          row?.accountNumber || "-",
          row?.clabe || "-",
          row?.beneficiary || "-",
        ]}
        actions={[
          {
            label: "Editar",
            icon: <EditOutlined />,
            onClick: handleEdit,
          },
          {
            label: "Eliminar",
            icon: <DeleteOutline />,
            onClick: handleDelete,
          },
        ]}
      />
    </Box>
  );
};

export default CuentasScreen;
